/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (min-width:1280px) and (max-width:1919px){.cal-month-view .cal-day-cell{min-height:100px}}@media screen and (min-width:1920px){.cal-month-view .cal-day-cell{min-height:100px}}.cal-month-view mwl-calendar-month-cell{overflow:hidden}.cal-month-view .single-line{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;padding:3px 0}.cal-month-view .cal-event-container{overflow:hidden}"];
export { styles as styles };
